import { render, staticRenderFns } from "./AddNewMaterialbankFile.vue?vue&type=template&id=3313b957&scoped=true&"
import script from "./AddNewMaterialbankFile.vue?vue&type=script&lang=js&"
export * from "./AddNewMaterialbankFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3313b957",
  null
  
)

export default component.exports